// UI Components
import { NotificationService } from 'ui-components/services/notification-service';
import { ModalService } from 'ui-components/services/modal-service';

import { JobPipelineService } from '../../services/job-pipeline-service';

// Store
import Global from '../../store/global-selectors';

// Steps
import { ShowVoidConfirmationStep } from './steps/show-void-confirmation-step';
import { ShowRequestingNotificationStep } from './steps/show-requesting-notification-step';
import { RequestVoidStep } from './steps/request-void-step';
import { VoidResponseStep } from './steps/void-response-step';
import { LaunchVoidModalStep } from './steps/launch-void-modal-step';
import { LoadDataToVoidModalStep } from './steps/load-data-to-void-modal-step';

export const BULK_VOID_PIPELINE = 'BULK_VOID_PIPELINE';

const pipeline = [
  ShowVoidConfirmationStep,
  ShowRequestingNotificationStep,
  RequestVoidStep,
  VoidResponseStep,
  LaunchVoidModalStep,
  LoadDataToVoidModalStep,
];

JobPipelineService.registerPipeline(BULK_VOID_PIPELINE, {
  pipeline,
  initialData: {},
  onExit: (jobId, state) => {
    const jobData = Global.selectJobPipelineJobDataByJobId(state, { jobId });
    const { notificationId, modalId } = jobData;
    if (notificationId) {
      NotificationService.removeNotification(notificationId);
    }
    if (modalId) {
      ModalService.closeModalById(modalId);
    }
  },
});
